import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import { apiUrl } from "../../api/config/config";
import authApi from "../../api/authApi";
import navigationApi from "../../api/navigationApi";
import { getLabel, getLanguage, setLanguage } from "../../tools/Dictionary";
import { dataValidator } from "../../tools/dataValidator";
import AlertModal from "../Commons/AlertModal";
import Global from "../../Global/Global";
import useMount from "../../hooks/useMount";
import useLog from "../../hooks/useLog";
import LoadingComponent from "../Commons/LoadingComponent";

import { setAuth, resetAuth } from "../../slices/authSlice";
import { setNavigations } from "../../slices/navigationSlice";
import { getLanguages } from "../../slices/languageSlice";

import "./Auth.css";
import logo from "../../images/Innovair_logo.png";
// import logoGoogle from "../../images/Google.png";
// //import logoFacebook from "../../images/Facebook.png";
// import logoMicrosoft from "../../images/Microsoft.png";

const AuthPage = (props) =>
	{
  //Logs
  const { logUserAction } = useLog();

	//Navigation
	const Navigate = useNavigate();

	//Parameters
	const { path } = useParams();

	//Redux
	const Dispatch = useDispatch();
	const Language = useSelector(getLanguages).filter(lang => lang.code != "ES"); // Exclude Spanish language

	//State
	const [ email, setEmail ] = useState("");
	const [ password, setPassword ] = useState("");
	const [ error, setError] = useState({});
	const [loading, setLoading] = useState(false);
	const [refresh, setRefresh] = useState(true);
	const [alert, setAlert] = useState({
		Title: "",
		Message: "",
		Confirm: "",
		onConfirm: () => void 0,
		Display: false
	});


	//Variables
	const component = "AuthPage";


	useMount(() =>
	{

		refreshAuth();

	}, []);

	const refreshAuth = async() => {



		let token = localStorage.getItem(Global.apiToken);

		if (token)
		{

			try{

				setRefresh(true);



				let response = await authApi.refreshAuth();


				if (response.Success){

					Dispatch(setAuth(response.Data.User));
					localStorage.setItem(Global.apiToken, response.Data.token || "");
					localStorage.setItem(Global.apiTokenAI, response.Data.tokenAI || "");
					setLanguage(response.Data.User.languageCode, "");


					authApi.setRequestHeader();

					
					if (response.Data.User.needFill){
						Navigate("/auth/fill");
					}
					else if (response.Data.User.isVerified){
						postLoginLoad();
          }
					else
						Navigate("/auth/toverify");
						

				}else{


					Dispatch(resetAuth());
					localStorage.setItem(Global.apiToken, "");
					localStorage.setItem(Global.apiTokenAI, "");
					authApi.setRequestHeader();

					setRefresh(false);

				}

			}catch(err){


				Dispatch(resetAuth());
				localStorage.setItem(Global.apiToken, "");
				localStorage.setItem(Global.apiTokenAI, "");
				authApi.setRequestHeader();

				setRefresh(false);

			}
		
		}else{
			setRefresh(false);
		}
	

	};

	const onChangeEmail = (e) =>
	{

		onValidateField("email", e.target.value)

		setEmail(email => e.target.value);

	};

	const onChangePassword = (e) => {

		onValidateField("password", e.target.value)

		setPassword(password => e.target.value);

	};


	// Validate field
	const onValidateField = (field = "", value = "") =>
	{
		let currentError = { ...error }; // Create a copy of the error object

		let Validation = []; // Array to store validation results

		let isValid = true; // Flag to track overall validity

		if (field == "email")
		{
			// If the field is "email"
			Validation = dataValidator([
				{ field: "email", value, listValidation: ["required", "email", "max:320"] },
			]);
		}

		if (field == "password")
		{
			// If the field is "password"
			Validation = dataValidator([
				{ field: "password", value, listValidation: ["required", "max:200"] },
			]);
		}

		if (field == "")
		{
			// If the field is empty (typically used for validating multiple fields at once)
			Validation = dataValidator([
				{ field: "email", value: email, listValidation: ["required", "email", "max:320"] },
				{ field: "password", value: password, listValidation: ["required", "max:200"] },
			]);
		}

		Validation.forEach(validation =>
		{
			// Iterate over each validation result
			if (validation.valid)
			{
				currentError[validation.field] = ""; // If valid, clear the corresponding error field
			} else
			{
				currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
				isValid = false; // Set isValid to false if any validation fails
			}
		});

		setError(currentError); // Update the error state

		return isValid; // Return the overall validity flag
	};


	//On click Sign in
	const onClickSignIn = async() => {


		if (!onValidateField())
			return;

		setLoading(true);

		try{

			let response = await authApi.signinAuth({ email, password });

			if (!response.Success)
			{
				setAlert({
					Title: getLabel("App", "Error"),
					Message: getLabel(response.Error.component, response.Error.label) || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
					Confirm: getLabel("App", "Ok"),
					onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
					Display: true
				});

				setLoading(false);

				return;
			}

			Dispatch(setAuth(response.Data.User));
			localStorage.setItem(Global.apiToken, response.Data.token || "");
			localStorage.setItem(Global.apiTokenAI, response.Data.tokenAI || "");
			setLanguage(response.Data.User.languageCode, "");


			authApi.setRequestHeader();

			if (response.Data.User.resetPassword)
				Navigate("/auth/reset");
			else if (response.Data.User.isVerified)
				postLoginLoad();
			else
			{
				Navigate("/auth/toverify");
			}

		}catch(err){

			setLoading(false);

			setAlert({
				Title: getLabel("App", "Error"),
				Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
				Confirm: getLabel("App", "Ok"),
				onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
				Display: true
			});

		}



	};

	//On click continue with google
	const onClickGoogle = async() => {

		
		// setAlert({
		// 	Title: getLabel("App", "Warning"),
		// 	Message: getLabel(component, "This feature is not available yet."),
		// 	Confirm: getLabel("App", "Ok"),
		// 	onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
		// 	Display: true
		// });

		window.location.href = apiUrl + "auth/google";

	};

	//On click continue with Azure
	const onClickAzure = async () =>
	{


		window.location.href = apiUrl + "auth/azure";

	};

	//On Click Sign up
	const onClickSignup = () => {

		Navigate("/auth/signup");

	};

	//onclick Forgot password
  const onClickForgot = () => {
		Navigate("/auth/forgot");
  }


	const postLoginLoad = async() => {

		try{

			//Navigation loading
			let response = await navigationApi.getNavigation();
		

			if (response.Success){



				let currentPath = path;

        logUserAction("Authentication", {});

				if (!currentPath) currentPath = "/";

				if (currentPath.startsWith('/auth'))
					currentPath = "/";

				

				Dispatch(setNavigations(response.Data));
				if (process.env.NODE_ENV === 'production')
					Navigate(currentPath || "/");
				else{
					Navigate(currentPath || "/");
				}
					
					//Navigate(path || "/");
					//Navigate("/administration/troubleshoot/process");

			}else{

				throw new Error(getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."));

			}






		}catch(err){

			setLoading(false);
			setRefresh(false);

			setAlert({
				Title: getLabel("App", "Error"),
				Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
				Confirm: getLabel("App", "Ok"),
				onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
				Display: true
			});

		}

	};

	const onChangeLanguage = async(e) => {

		let selectedLanguage = e.target.value;

		setLoading(true); 

		await new Promise(resolve => setTimeout(resolve, 10));
		

		if (selectedLanguage != getLanguage().code){
			setLanguage(selectedLanguage, "");
			window.location.reload();

		}

	};

	if (refresh)
		return(
			<div className="auth_page_cont">
				<div className="page_loading" style={{ fontSize: "160%" }}>
					{getLabel("App", "Loading")}<span>.</span><span>.</span><span>.</span>
				</div>
			</div>
		);

	
	return (
		<div className="auth_page_cont">
			<AlertModal
				Title={alert.Title}
				Message={alert.Message}
				Confirm={alert.Confirm}
				onConfirm={alert.onConfirm}
				Display={alert.Display}
			/>
			<div className="auth_page_title">
				<img src={logo} alt="logo" style={{width: "50%"}} />
			</div>
			<div className="auth_cont">
				<LoadingComponent 
					display={loading}
					label={getLabel("App", "Loading")}
					isCover={true}
				/>
				<div className="auth_cont_title">
					{getLabel(component, "Authentification")}
				</div>
				<div className="auth_cont_body">
					<input 
					className="form-control auth_cont_login_input"
						type="text"
						placeholder={getLabel(component, "Email")}
						value={email}
						onChange={onChangeEmail}
					/>
					{error["email"] &&
						<div className="auth_signup_row_error">
							{error["email"]}
						</div>
					}

					<input
						className="form-control auth_cont_login_input"
						type="password"
						placeholder={getLabel(component, "Password")}
						value={password}
						onChange={onChangePassword}
					/>
					{error["password"] &&
						<div className="auth_signup_row_error">
							{error["password"]}
						</div>
					}

					<div className="auth_cont_footer_forgot" onClick={onClickForgot}>
						{getLabel(component, "Forgot your password?")}
					</div>

				</div>

				<div className="auth_cont_footer">
					<input
						type="button"
						className="page_button auth_cont_login_button"
						value={getLabel(component, "Sign in")}
						onClick={onClickSignIn}
						disabled={loading}
					/>

					<div className="auth_cont_footer_signup">
						{getLabel(component, "Don't have an account?")} <span onClick={onClickSignup}>{getLabel(component, "Sign up")}</span>
					</div>
				</div>

				{/* <div className="auth_cont_divider">
					{getLabel(component, "OR")}
				</div>

				<div className="auth_cont_login_api">
					<div className="page_button auth_cont_login_button" style={{ backgroundColor: "white", borderColor: "#0076a5", color: "#0076a5" }} onClick={onClickGoogle}>
						<div className="auth_login_service_icon" >
							<img src={logoGoogle} alt="logo" style={{ width: "25px", height: "25px" }} />
						</div>
						<div className="auth_login_service_text" >
							{getLabel(component, "Continue with ")}Google
						</div>
					</div>
				</div>
			 */}
				{/* <div className="auth_cont_login_api">
					<div className="page_button auth_cont_login_button" style={{ backgroundColor: "white", borderColor: "#0076a5", color: "#0076a5" }} onClick={onClickGoogle}>
						<div className="auth_login_service_icon" >
							<img src={logoFacebook} alt="logo" style={{ width: "25px", height: "25px" }} />
						</div>
						<div className="auth_login_service_text" >
							{getLabel(component, "Continue with ")}Facebook
						</div>
					</div>
				</div> */}

				{/* <div className="auth_cont_login_api">
					<div className="page_button auth_cont_login_button" style={{ backgroundColor: "white", borderColor: "#0076a5", color: "#0076a5" }} onClick={onClickAzure}>
						<div className="auth_login_service_icon" >
							<img src={logoMicrosoft} alt="logo" style={{ width: "25px", height: "25px" }} />
						</div>
						<div className="auth_login_service_text" >
							{getLabel(component, "Continue with ")}Microsoft
						</div>
					</div>
				</div> */}
				<div className="auth_language_cont">
					<select
						value={getLanguage().code || ""}
						className="page_select_input"
						onChange={onChangeLanguage}
						style={{ width: "140px", textAlign: "center", color: "black", fontSize: "80%" }}
						disabled={loading}
					>
						{Language.map((l, index) => (
							<option key={index} value={l.code} style={{ textAlign: "center", color: "black" }}>
								{l.name}
							</option>
						))}
					</select>
				</div>
			</div>

			
		</div>
	);

};


export default AuthPage;
